import React, { useState } from "react";
import { Link } from "gatsby";
import { Paper, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PopUp } from "./../";

const Img = styled(Paper)(({ theme }) => ({
	display: "block",
	backgroundRepeat: "no-repeat",
	backgroundPosition: "center center",
	backgroundSize: "cover",
	WebkitBackgroundSize: "cover",
	paddingTop: "55%",
	"&.full": {
		paddingTop: "0",
		"& img": {
			display: "block",
			width: "100%",
			height: "auto",
		},
	},
	"&.portrait": {
		paddingTop: "136%",
	},
	"&.square": {
		paddingTop: "100%",
	},
	"&.rounded": {
		paddingTop: "100%",
		borderRadius: "50%",
	},
	"& img": {
		display: "none",
	},
	"&:after": {
		display: "none !important",
	},
}));

function ImageComponent({
	src,
	alt,
	href,
	caption,
	width,
	height,
	popup,
	orientation = "landscape",
}) {
	const [elevation, setElevation] = useState(href ? 1 : 0);
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	if (!src) return <></>;

	let attrs = {};
	if (href || popup) {
		attrs = {
			onFocus: (e) => setElevation(10),
			onBlur: (e) => setElevation(10),
			onMouseEnter: (e) => setElevation(10),
			onMouseLeave: (e) => setElevation(1),
			cursor: "pointer",
		};
		if (popup && !href) {
			attrs.component = "a";
			attrs.href = src;
		}
	}
	if (href) {
		let _is_external = href.includes("http");
		if (_is_external) {
			attrs.target = "_blank";
			attrs.rel = "noreferrer";
			attrs.component = "a";
			attrs.href = href;
		} else {
			attrs.component = Link;
			attrs.to = href;
		}
	}
	if (popup) {
		attrs.onClick = function (e) {
			e.preventDefault();
			handleOpen();
		};
	}

	return (
		<>
			{popup && (
				<PopUp
					open={open}
					handleClose={handleClose}
					sx={{
						top: 0,
						left: 0,
						transform: "translate(3%, 3%)",
						width: "94%",
						height: "94%",
						boxShadow: "none",
						bgcolor: "transparent",
						border: "none",
						maxWidth: "none",
					}}
				>
					<Box
						sx={{
							backgroundImage: `url(${src})`,
							position: "absolute",
							top: 0,
							left: 0,
							width: "100%",
							height: "100%",
							backgroundSize: "contain",
							backgroundRepeat: "no-repeat",
							backgroundPosition: "center center",
							backgroundColor: "transparent",
							border: "none",
							cursor: "pointer",
						}}
						onClick={handleClose}
						component="button"
					></Box>
				</PopUp>
			)}
			<Box
				className={`image`}
				component="figure"
				sx={{
					display: "block",
					marginLeft: 0,
					marginRight: 0,
					marginBottom: 0,
				}}
			>
				<Img
					{...attrs}
					elevation={elevation}
					className={`${orientation} image-block`}
					style={{ backgroundImage: `url(${src})` }}
				>
					<img src={src} alt={alt} width={width} height={height} />
				</Img>
				{caption && (
					<Box
						sx={(theme) => ({
							display: "block",
							fontSize: "0.76em",
							fontStyle: "normal",
							textAlign: "left",
							opacity: 0.6,
							marginTop: theme.spacing(1),
							marginBottom: theme.spacing(1),
							color: theme.palette.grey["700"],
							"& em": {
								display: "block",
								textAlign: "right",
								fontStyle: "italic",
							},
						})}
						dangerouslySetInnerHTML={{ __html: caption }}
						component="figcaption"
					/>
				)}
			</Box>
		</>
	);
}

export default ImageComponent;
